import React from "react"
import { Helmet } from "react-helmet"
import SkewBg from "../../components/SkewBg/SkewBg"
import SkewPlax from "../../components/SkewPlax/SkewPlax"
import image2 from "../../assets/images/marc13.jpg"
const classes = require('./Leadership.module.scss')

const skewTitle = (<h1>A Commitment to Excellence<br/>That Starts From the Top</h1>)
const subtitle = (<h2>Company Leadership</h2>)
// Chad Carda, MD, ACEP /// Derek "Levi" Leivestad
const plaxContent= (
  <div className={[classes.plLeads].join(' ')}>
    <div className={[classes.tier, classes.t1].join(' ')}>
      <div className={classes.plItem}><p className={classes.name}>Jerry Dale</p><p className={classes.title}>President/Owner</p></div>
      <div className={classes.plItem}><p className={classes.name}>Steve Dale</p><p className={classes.title}>CEO/Owner</p></div>
    </div>
    <hr className={classes.tierHr} />

    <div className={[classes.tier, classes.t2].join(' ')}>
      <div className={classes.plItem}><p className={classes.name}>Dustin Hunsaker</p><p className={classes.title}>Chief Operating Officer</p></div>
      <div className={classes.plItem}><p className={classes.name}>Patricia Bettles</p> <p className={classes.title}>Chief Financial Officer</p></div>
    </div>
    <hr className={classes.tierHr} />
      
    <div className={[classes.tier, classes.t3].join(' ')}>
      <div className={classes.plItem}><p className={classes.name}>Ken Maraman</p><p className={classes.title}>Director of Medical Operations</p></div>
      <div className={classes.plItem}><p className={classes.name}>Derek Leivestad</p><p className={classes.title}>Chief Pilot</p></div>
      <div className={classes.plItem}><p className={classes.name}>Trevor Puckett</p><p className={classes.title}>Director of Aviation Maintenance</p></div>
    </div>
    <hr className={classes.tierHr} />
    
    <div className={[classes.tier, classes.t4].join(' ')}>
      <div className={classes.plItem}><p className={classes.name}>Georgia Dale</p><p className={classes.title}>Director of Executive Services</p></div>    
      <div className={classes.plItem}><p className={classes.name}>Colby Bettles</p><p className={classes.title}>Education & Compliance Specialist</p></div>
      <div className={classes.plItem}><p className={classes.name}>Chad Carda</p><p className={classes.title}>Medical Director</p></div>
    </div>
  </div>
)

const leadership = () => {
  return (
    <div className={classes.LeadershipPage}>
      <Helmet>
        <title>Medical Air Rescue Company Leadership & Staff</title>
        <meta name="description" content="Our leadership team is a large part of why Medical Air Rescue Company has been a trusted provider of first-class, emergency medical care for almost 40 years." />
      </Helmet>

      <SkewBg title={skewTitle} subtitle={subtitle} addClass="Leadership" />

      <SkewPlax content={plaxContent} addClass="Leadership" wrap="medDef" />
      <div className={[classes.medDef, classes.lrmed].join(' ')}>
        <div className={[classes.leadRow, classes.three].join(' ')}>
          <div className={[classes.image, classes.image2].join(' ')}><img src={image2} alt="Medical Air Rescue Team" /></div>
          <div className={[classes.itemGroup, classes.ig2].join(' ')}>
            <div className={classes.item}><p className={classes.name}>Josh Kauffman <span className={classes.title}> <span>...</span>  Project and Facilities</span></p></div>
            <div className={classes.item}><p className={classes.name}>Kyra Anderson <span className={classes.title}> <span>...</span> Digital Marketing Specialist</span></p></div>
            <div className={classes.item}><p className={classes.name}>Tanner Thorfinnson <span className={classes.title}> <span>...</span> Base Lead - Rapid City, SD</span></p></div>
            <div className={classes.item}><p className={classes.name}>Duane Lamb <span className={classes.title}> <span>...</span> Base Lead - Valentine, NE</span></p></div>
            <div className={classes.item}><p className={classes.name}>Leslie Peterson <span className={classes.title}> <span>...</span> Base Lead - Rosebud, SD</span></p></div>
            <div className={classes.item}><p className={classes.name}>Shon Maloy <span className={classes.title}> <span>...</span> Base Lead - Hugo, OK</span></p></div>
            <div className={classes.item}><p className={classes.name}>Glenn Warnock <span className={classes.title}> <span>...</span> Base Lead - McKinney, TX</span></p></div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default leadership